import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { notificationsTranslationRef } from '@backstage/plugin-notifications';

/**
 * Every Notificações text in pt-BR (Story 2.3, AC-18), in the words of the
 * UX label sheet. The layout and the behaviour stay the plugin's. The
 * pagination keeps its single-brace placeholders (`{from}`, `{to}`,
 * `{count}`), which the stock table fills itself.
 */
export const notificationsMessages = TranslationBlueprint.make({
  name: 'byx-notifications',
  params: {
    resource: createTranslationMessages({
      ref: notificationsTranslationRef,
      messages: {
        'notificationsPage.title': 'Notificações',
        'notificationsPage.tableTitle.all_one': 'Todas ({{count}})',
        'notificationsPage.tableTitle.all_other': 'Todas ({{count}})',
        'notificationsPage.tableTitle.saved_one': 'Salvas ({{count}})',
        'notificationsPage.tableTitle.saved_other': 'Salvas ({{count}})',
        'notificationsPage.tableTitle.unread_one': 'Não lidas ({{count}})',
        'notificationsPage.tableTitle.unread_other': 'Não lidas ({{count}})',
        'notificationsPage.tableTitle.read_one': 'Lidas ({{count}})',
        'notificationsPage.tableTitle.read_other': 'Lidas ({{count}})',
        'filters.title': 'Filtros',
        'filters.view.label': 'Ver',
        'filters.view.unread': 'Não lidas',
        'filters.view.read': 'Lidas',
        'filters.view.saved': 'Salvas',
        'filters.view.all': 'Todas',
        'filters.createdAfter.label': 'Enviadas',
        'filters.createdAfter.placeholder': 'Notificações desde',
        'filters.createdAfter.last24h': 'Últimas 24 h',
        'filters.createdAfter.lastWeek': 'Última semana',
        'filters.createdAfter.anyTime': 'Qualquer data',
        'filters.sortBy.label': 'Ordenar por',
        'filters.sortBy.placeholder': 'Campo para ordenar',
        'filters.sortBy.newest': 'Mais recentes primeiro',
        'filters.sortBy.oldest': 'Mais antigas primeiro',
        'filters.sortBy.topic': 'Tópico',
        'filters.sortBy.origin': 'Origem',
        'filters.severity.label': 'Gravidade mínima',
        'filters.severity.critical': 'Crítica',
        'filters.severity.high': 'Alta',
        'filters.severity.normal': 'Normal',
        'filters.severity.low': 'Baixa',
        'filters.topic.label': 'Tópico',
        'filters.topic.anyTopic': 'Qualquer tópico',
        'table.emptyMessage': 'Nenhuma notificação para mostrar.',
        'table.pagination.firstTooltip': 'Primeira página',
        'table.pagination.labelDisplayedRows': '{from}–{to} de {count}',
        'table.pagination.labelRowsSelect': 'linhas',
        'table.pagination.lastTooltip': 'Última página',
        'table.pagination.nextTooltip': 'Próxima página',
        'table.pagination.previousTooltip': 'Página anterior',
        'table.bulkActions.markAllRead': 'Marcar todas como lidas',
        'table.bulkActions.markSelectedAsRead':
          'Marcar selecionadas como lidas',
        'table.bulkActions.returnSelectedAmongUnread':
          'Voltar selecionadas para não lidas',
        'table.bulkActions.saveSelectedForLater':
          'Salvar selecionadas para depois',
        'table.bulkActions.undoSaveForSelected':
          'Desfazer salvar das selecionadas',
        'table.confirmDialog.title': 'Tem certeza?',
        'table.confirmDialog.markAllReadDescription':
          'Todas as notificações serão marcadas como lidas.',
        'table.confirmDialog.markAllReadConfirmation': 'Marcar todas',
        'table.confirmDialog.cancel': 'Cancelar',
        'table.errors.markAllReadFailed':
          'Não foi possível marcar todas as notificações como lidas.',
        'sidebar.title': 'Notificações',
        'sidebar.errors.markAsReadFailed':
          'Não foi possível marcar a notificação como lida.',
        'sidebar.errors.fetchNotificationFailed':
          'Não foi possível carregar a notificação.',
        'settings.title': 'Configurações de notificação',
        'settings.errorTitle': 'Não foi possível carregar as configurações.',
        'settings.noSettingsAvailable':
          'Nenhuma configuração de notificação disponível. Volte mais tarde.',
        'settings.table.origin': 'Origem',
        'settings.table.topic': 'Tópico',
        'settings.errors.useNotificationFormat':
          'useNotificationFormat precisa estar dentro de um NotificationFormatProvider',
        'unreadCard.title_one': 'Últimas não lidas ({{count}})',
        'unreadCard.title_other': 'Últimas não lidas ({{count}})',
        'unreadCard.viewAll': 'Ver todas',
        'unreadCard.emptyState': 'Tudo em dia!',
        'unreadCard.columnNotification': 'Notificação',
        'unreadCard.columnActions': 'Ações',
        'unreadCard.resultsCount': '{{displayed}} de {{total}} resultados',
      },
    }),
  },
});
